import { render } from "./AssignmentEditor.vue?vue&type=template&id=0ac2f3be"
import script from "./AssignmentEditor.vue?vue&type=script&lang=js"
export * from "./AssignmentEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__